import { WeenatColor } from '@weenat/theme'
import CountIndicator from 'app/src/kit/CountIndicator'
import Text from 'app/src/kit/Text'
import isNil from 'lodash-es/isNil'
import Tab, { TabProps } from './Tab'
import { useTabsContext } from './TabsContext'

interface TabsItemProps {
  value: string | number
  label: string
  onPress?: () => void
  /** Count badge displayed to the right of the label */
  indicator?: number
  flex?: TabProps['flex']
  focusColor?: WeenatColor
  focusBorderColor?: WeenatColor
  className?: string
}

function TabsItem({
  value,
  label,
  onPress,
  indicator,
  flex,
  focusColor,
  focusBorderColor,
  className
}: TabsItemProps) {
  const { currentTab, onTabChange } = useTabsContext()

  const isFocused = currentTab === value
  const color: WeenatColor = isFocused ? 'primary.500' : 'grayscale.black'

  return (
    <Tab
      flex={flex}
      isFocused={isFocused}
      focusColor={focusColor}
      focusBorderColor={focusBorderColor}
      onPress={() => {
        onPress?.()
        onTabChange(value)
      }}
      p='md'
      className={className}
    >
      <Text $fontWeight='bold' $textAlign='center' $color={color} $ellipsis>
        {label}
      </Text>
      {!isNil(indicator) ? (
        <CountIndicator count={indicator} backgroundColor={color} color={'grayscale.white'} />
      ) : null}
    </Tab>
  )
}

export default TabsItem
